import React from 'react';
import Layout from 'components/layout';
import Intro from 'components/intro';
import { graphql, Link } from 'gatsby';
import ArtDirectedFullBackground from 'components/ArtDirectedFullBackground'

const title = "Intro to 3ds Max";
const description = "Looking for a 3ds Max course that takes you from A-to-Z? From finding your way around the interface, to pipeline integration, and everything in between - get up to speed in 3ds Max.";
const assetsURL = "https://area-resources-prd.autodesk.com/downloads/Intro3dsMax-2021_ProjectFiles.zip";
const firstLessonPath = "01-navigating-the-interface";

import maxLogo from 'assets/images/3dsmax-logo.svg';

const prodLogos = [
    {url: maxLogo, alt: 'Autodesk 3DS MAX'},
];

const Index = ({ data }) => {

  return (

  <ArtDirectedFullBackground halfBG={false} desktopBG={data.desktop} mediumBG={data.medium} smallBG={data.small} className="intro-3ds-hero-img">
      <Layout title={title} pageDescription={description} imgURL={data.ogImage.childImageSharp.fixed.src}>

          <Intro title={title}
                 description={description}
                 assetsURL={assetsURL}
                 firstLessonPath={firstLessonPath}
                 prodLogos={prodLogos}>
          </Intro>

        <div className="image-credits"><a href="https://quantillion.wixsite.com/home" target="__blank" rel="noopener noreferrer">Image courtesy of Quantillion.</a></div>
      </Layout>
    </ArtDirectedFullBackground>
)};

export default Index;

export const query = graphql`
  query maxHomeQuery {
    ogImage: file(relativePath: {eq: "images/og_intro_3dsMax.jpg"}) {
      childImageSharp {
        fixed {
          src
        }
      }
    }
    desktop: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    medium: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1400, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    small: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 490, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;


